import { FC } from 'react';
import CheckBox from '@qlub-dev/qlub-kit/dist/components/Checkbox';
import classNames from 'classnames';

import styles from './index.module.scss';

export interface IConsentBoxProps {
    hasConsented: boolean;
    handleClick: (e: Event) => void;
    Message?: JSX.Element;
    className?: string;
}

const ConsentBox: FC<IConsentBoxProps> = ({ hasConsented, handleClick, Message, className }) => {
    return (
        <div className={classNames(styles.container, className)}>
            <CheckBox checked={hasConsented} onClick={handleClick} />
            {Message}
        </div>
    );
};

export default ConsentBox;
